import axios from "axios";
import authManager from "./authManager";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  withCredentials: true,
});
instance.interceptors.request.use((config) => {
  config.params = config.params || {};
  return config;
});

export { instance };

let logoutFn = null;

export const setLogoutFunction = (fn) => {
  logoutFn = fn;
};

export const setupInterceptors = (instance) => {
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response?.status;
      const url = error.config?.url || "";

      const bypassUrls = ["/api/user/v1/profile"];
      const shouldBypass = bypassUrls.some((u) => url.includes(u));

      console.log(error);
      
      // if ((status === 401 || status === 403) && !shouldBypass && logoutFn) {
      //   logoutFn();
      // }

     // return Promise.reject(error);
    }
  );
};
// instance.interceptors.request.use(async (config) => {
//   config.params = config.params || {};
//   const method = config.method?.toLowerCase();
//   const needsCsrf = ["post", "put", "patch", "delete"].includes(method || "");
//   if (needsCsrf) {
//     const res = await instance.get("/api/csrf-token");
//     config.headers["X-CSRF-Token"] = res.data.csrfToken;
//   }
//   return config;
// });

const apiRequest = {
  getSetting: ({ v = "v1" } = {}) => instance.get(`/api/${v}/siteSetting`),
  
  getPartnerDashboardData: ({ v = "v1" } = {}) =>
    instance.get(`/api/user/${v}/getPartnerDashboardData`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  getOrderedProductWithAttributeDetail: ({ v = "v1", id } = {}) =>
    instance.get(`/api/user/${v}/getOrderedProductWithAttributeDetail/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  getHomeData: ({ v = "v1" } = {}) =>
    instance.get(`/api/user/${v}/getHomeDetails`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  getProductHome: ({ v = "v1", body } = {}) =>
    instance.post(`/api/${v}/getProduct`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  confirmOrderProducts: ({ v = "v1", id = "", body } = {}) =>
    instance.post(`/api/user/${v}/confirmOrderProducts/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  getProductById: ({ v = "v1", id = null } = {}) =>
    instance.get(`/api/${v}/getProduct/${id}`),

  searchProducts: ({ v = "v1", query = null } = {}) =>
    instance.get(`/api/${v}/searchProducts?query=${query}`),

  resetPassword: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/user/${v}/resetPassword`, body),

  login: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/user/${v}/login`, body),

  sendOtp: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/user/${v}/sendOtp`, body),

  register: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/user/${v}/register`, body),

  getProfile: ({ v = "v1" } = {}) =>
    instance.get(`/api/user/${v}/profile`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  updateProfile: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/user/${v}/updateProfile`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  addToCart: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/user/${v}/addToCart`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  addToWishList: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/user/${v}/addToWishlist`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  removeFromCart: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/user/${v}/removeFromCart/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  removeFromWishlist: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/user/${v}/removeFromWishlist/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  getCartItems: ({ v = "v1" } = {}) =>
    instance.get(`/api/user/${v}/getCartItems`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  getPaymentOptions: ({ v = "v1", vendorId } = {}) => {
    const url = `/api/user/${v}/getPaymentOptions/${vendorId}`;
    return instance.get(url, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    });
  },
  getVendorTaxSettings: ({ v = "v1", vendorId } = {}) => {
    const url = `/api/user/${v}/getVendorTaxSettings/${vendorId}`;
    return instance.get(url, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    });
  },

  getWishlistItems: ({ v = "v1" } = {}) =>
    instance.get(`/api/user/${v}/getWishlistItems`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  // 1️⃣ Create Razorpay Order
  createRazorpayOrder: ({ v = "v1", body } = {}) =>
    instance.post(`/api/user/${v}/createRazorpayOrder`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  // 2️⃣ Verify Razorpay Payment ✅ (FIXED)
  verifyRazorpayPayment: ({ v = "v1", body } = {}) =>
    instance.post(`/api/user/${v}/verifyRazorpayPayment`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  createScanPayOrder: ({ v = "v1", body } = {}) =>
    instance.post(`/api/user/${v}/createScanPayOrder`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  updateOrder: ({ v = "v1", id = "", body } = {}) =>
    instance.put(`/api/user/${v}/updateOrder/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
        "Content-Type": "multipart/form-data",
      },
    }),

  applyCoupon: ({ v = "v1", body } = {}) =>
    instance.post(`/api/user/${v}/applyCoupon`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  getOrders: ({ v = "v1", body } = {}) =>
    instance.post(`/api/user/${v}/getOrders`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  getUserOrders: ({ v = "v1", body } = {}) =>
    instance.post(`/api/user/${v}/getUserOrders`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  getCoupon: ({ v = "v1", body } = {}) =>
    instance.post(`/api/user/${v}/getCoupon`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  getVendorManagerBySuperVendor: ({ v = "v1", body } = {}) =>
    instance.post(`/api/user/${v}/getVendorManagerBySuperVendor`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  getCartDetails: ({ v = "v1", body } = {}) =>
    instance.post(`/api/user/${v}/getCartDetails`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  submitOrderRating: ({ v = "v1", body } = {}) =>
    instance.post(`/api/user/${v}/submitOrderRating`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
};

export default apiRequest;
